module.exports = __webpack_public_path__ + "static/media/show-wrinkles.9b747e5a.svg";